import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Graphic from "@arcgis/core/Graphic";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import Query from "@arcgis/core/rest/support/Query";
import {
  point,
  line,
  polygon,
  selectPoint,
  selectLine,
  selectPolygon,
  selectCircle,
  selectRectangle,
  bufferPolygon
} from "./symbols";
import { highLighthandles as handles, highLighthandles, layerViewHighlight } from "../../../../handles/Handles";
import { removeFromSelectionAction } from "../../../../templates/popupTemplate/actions";
import getActiveFieldsFromPopupTemplate from "../../../../utility-tools/getActiveFieldsFromPopupTemplate";

const SelectVMOnView = async (viewN) => {
  let viewf = await viewN.when((view)=>{return view})
  let webmap = viewf.map

  const FilterModel = await webmap.when(async() => {
    const sketchViewModel = await sketchTool(viewf);

    const model = {
      sketchViewModel: sketchViewModel,
      clearLayerHandler: ()=>clearLayerHandler(viewf,sketchViewModel),
    };
    return model;
  });
  return FilterModel;
};
export default SelectVMOnView;

export const clearLayerHandler=(view,sketchViewModel) => {
  let bufferLayer = view.map.allLayers.filter(
    (layer) => layer.id === "bufferLayer"
  ).getItemAt(0);
  sketchViewModel.cancel();
  handles.removeAll();
  clearGeometry([sketchViewModel.layer, bufferLayer]);
}

export const drawGeometryHandler=(e,view,sketchViewModel,mode="") => {
  e.preventDefault()
  view.when(()=>{
  let bufferLayer = view.map.allLayers.filter(
    (layer) => layer.id === "bufferLayer"
  ).getItemAt(0);
  const geometryType = e.target.value;
  sketchViewModel.cancel();
  clearGeometry([sketchViewModel.layer, bufferLayer]);
  if(mode.length){
    sketchViewModel.create(geometryType,{mode:mode});
  }else{
    sketchViewModel.create(geometryType);
  }
  
})
}

export const selectDataHandler=async(view,attributeObject,addToCurrentSelection) => {
  
  let webmap=view.map
  let bufferLayer = view.map.allLayers.filter(
    (layer) => layer.id === "bufferLayer"
  ).getItemAt(0);
  let sketchLayer = view.map.allLayers.filter(
    (layer) => layer.id === "sketchLayer"
  ).getItemAt(0)
  let selectionLayer = view.map.allLayers.filter(
    (layer) => layer.id === "selectionLayer"
  ).getItemAt(0)
  if(!addToCurrentSelection){
  selectionLayer.removeAll();
  }
  let geometries = [];
  bufferLayer.graphics.forEach((graphic) => {
    geometries.push(graphic.geometry);
  });
  if (geometries.length === 0) {
    sketchLayer.graphics.forEach((graphic) => {
      geometries.push(graphic.geometry);
    });
  }
  let duplicatesMap=createMapOfGraphicsInGraphicLayer(selectionLayer);
   const layerList=webmap.allLayers.filter(layer=>{
    if(attributeObject.layerId.length){
      return layer.id===attributeObject.layerId
    }else{
      return layer.type === "feature" && layer.visible
    }
   })
    for(const layer of layerList){
      if (layer.type === "feature" && layer.visible) {
        const visibleFieldObjectsList=getActiveFieldsFromPopupTemplate(layer.fields,layer.popupTemplate)
        const fieldNameList=visibleFieldObjectsList.map(field=>field.name)
        fieldNameList.push("OBJECTID")
        let query:Query =new Query({
          units: "feet",
          outFields: fieldNameList,
          returnGeometry: true,
          spatialRelationship: "intersects",
          where:attributeObject.queryString,
          outSpatialReference:view.spatialReference
        });
        if(geometries.length>0){
          query.geometry=geometries[0]
        }
        let popupTemplate=layer.popupTemplate.clone()
        popupTemplate.set("actions", [removeFromSelectionAction]);
        try{
          await queryLayerAddToSelectionGraphicLayer(layer,query,popupTemplate,selectionLayer,duplicatesMap)

        }catch(error){console.log('error')}
      }
    };
  handles.removeAll();
}

export const removeFromSelectionHandler = async (view, attributeObject) => {
  const {layerId, queryString} = attributeObject;

  const {map}=view
  let selectionLayer = view.map.allLayers.filter(
    (layer) => layer.id === "selectionLayer"
  ).getItemAt(0);
  let bufferLayer = view.map.allLayers.filter(
    (layer) => layer.id === "bufferLayer"
  ).getItemAt(0);
  let sketchLayer = view.map.allLayers.filter(
    (layer) => layer.id === "sketchLayer"
  ).getItemAt(0);

    let geometries = [];
  bufferLayer.graphics.forEach((graphic) => {
    geometries.push(graphic.geometry);
  });
  if (geometries.length === 0) {
    sketchLayer.graphics.forEach((graphic) => {
      geometries.push(graphic.geometry);
    });
  }
  // clearGeometry([bufferLayer, sketchLayer]);

     const layerList=map.allLayers.filter(layer=>{
    if(layerId.length){
      return layer.id===attributeObject.layerId
    }else{
      return layer.type === "feature" && layer.visible
    }
   })

   for(const layer of layerList){
    if (layer.type === "feature") {
        let query:Query =new Query({
          units: "feet",
          spatialRelationship: "intersects",
          where:queryString,
          outSpatialReference:view.spatialReference
        });
        if(geometries.length>0){
          query.geometry=geometries[0]
        }
        console.log("Query to remove:", query);
        console.log("Layer to remove from:", layer.title);
        layer.queryObjectIds(query).then((objectIds) => {
          if (objectIds.length === 0) {
            return;
          }
          for(const objectId of objectIds) {
            const graphic = selectionLayer.graphics.find((g) => g.attributes.OBJECTID === objectId);
            if (graphic) {
              selectionLayer.remove(graphic);
              console.log(`Removed graphic with OBJECTID: ${objectId}`);
            } else {
              console.log(`Graphic with OBJECTID: ${objectId} not found in selectionLayer.`);
            }
          }
        })
    }
  }

  // handles.removeAll();
  // if (selectionLayer.graphics.length > 0) {
  //   selectionLayer.graphics.forEach((graphic) => {
  //     if (graphic.selected) {
  //       selectionLayer.remove(graphic);
  //     }
  //   });
  // }
}

const sketchTool = async (view) => {
  let viewf = await view.when((view)=>{return view})
  let sketchLayer = viewf.map.allLayers.filter(
    (layer) => layer.id === "sketchLayer"
  ).getItemAt(0);
  const sketchViewModel: any = new SketchViewModel({
    layer: sketchLayer,
    view: view,
    pointSymbol: point as any,
    polylineSymbol: line as any,
    polygonSymbol: polygon as any,
  });


  return sketchViewModel
};
export const createSketchToolHandlers = (view,sketchViewModel,attributeObject,bufferSize)=>{
    let bufferLayer = view.map.allLayers.filter(
    (layer) => layer.id === "bufferLayer"
  ).getItemAt(0);
  let createHandle=sketchViewModel.on("create", (event) => {
    if (event.state === "complete") {
      bufferVariablesChanged(bufferSize,view)
      selectHighlightFromClientSideFilter(view, attributeObject, event.graphic.geometry, bufferSize);
    }
  });

  let updateHandle=sketchViewModel.on("update", (event) => {
    if (event.state === "complete") {
      bufferLayer.removeAll();
      selectHighlightFromClientSideFilter(view,attributeObject, event.graphics[0].geometry, bufferSize);
    }
  });
  return [createHandle,updateHandle]
}
export const clearGeometry = (layers) => {
  //handles.removeAll()
  layers.forEach((layer) => {
    if (layer.type === "graphics") {
      layer.removeAll();
    }
  });
};

export const bufferVariablesChanged = async(value,view) => {
  let viewf = await view.when((view)=>{return view})
  let bufferLayer = viewf.map.allLayers.filter(
    (layer) => layer.id === "bufferLayer"
  ).getItemAt(0);
  let sketchLayer = viewf.map.allLayers.filter(
    (layer) => layer.id === "sketchLayer"
  ).getItemAt(0);
  let bufferSize = value;
  clearGeometry([bufferLayer]);
  if (bufferSize > 0) {
    if (sketchLayer.graphics.length > 0) {
      const bufferGeometry = geometryEngine.buffer(
        sketchLayer.graphics.getItemAt(0).geometry,
        bufferSize,
        "feet"
      );

      if (bufferLayer.graphics.length === 0) {
        let graphic: any = {
          geometry: bufferGeometry as any,
          symbol: bufferPolygon,
        };
        bufferLayer.add(graphic);
      } else {
      }
    }
  } else {
    bufferLayer.removeAll();
  }
};

export const bufferChangeHandler=(bufferValue,view,attributeObject)=>{
  bufferVariablesChanged(bufferValue,view)
  if (bufferValue > 0) {
    let sketchLayer = view.map.allLayers.filter(
      (layer) => layer.id === "sketchLayer"
    ).getItemAt(0);
    if (sketchLayer.graphics.length > 0) {
      let geometry = sketchLayer.graphics.getItemAt(0).geometry;

  selectHighlightFromClientSideFilter(view,attributeObject, geometry, bufferValue);
    }}
}

const selectHighlightFromClientSideFilter = async(view, attributeObject, geometry, buffer) => {
  let v = await view.when(()=>view as any)
  let filterLayers = v.map.allLayers.filter((layer: { type: string,id:string }) => {
    if(attributeObject.layerId.length>0){
      if(layer.id===attributeObject.layerId){
        return layer
      }
    }else{
    if (layer.type === "feature") {
      return layer;
    }
  }
  });
  highLighthandles.removeAll()
filterLayers.forEach((layer) => {
    v.whenLayerView(layer).then((layerView: any) => {
      queryLayer(layerView, geometry, buffer).then((features) => {
        layerViewHighlight(layerView, features.features, layer.title);
      });
    });
  });
};
const queryLayer = async (layer, sketchGeometry, bufferSize: any, where?) => {
  let query = new Query({
    geometry: sketchGeometry,
    distance: bufferSize,
    units: "feet",
    outFields: ["*"],
    returnGeometry: true,
    spatialRelationship: "intersects",
    where: where,
  });
  return await layer.queryFeatures(query);
};

export const queryLayerAddToSelectionGraphicLayer=async(layer,query,popupTemplate,selectionGraphicLayer,duplicatesMap)=>{
  await layer.queryFeatures(query).then((res) => {
    res.features.forEach((feature) => {
     // if(duplicatesMap)
      if(!isFeatureDuplicateInGraphicLayerMap(feature,duplicatesMap)){

      let graphic: any = new Graphic({
        geometry: feature.geometry,
        attributes: feature.attributes,
        popupTemplate: popupTemplate,
      });

      graphic.parentLayerTitle = layer.title;
      graphic.parentLayerUrl = layer.url;
      graphic.parentLayerId = layer.id;
      graphic.parentCustomParameters={OCLandInsightsID:layer.customParameters?.OCLandInsightsID ? layer.customParameters.OCLandInsightsID : ""};
      if (feature.geometry.type === "point") {
        graphic.symbol = selectPoint as any;
      }
      if (feature.geometry.type === "multipoint") {
        graphic.symbol = selectPoint as any;
      }
      if (feature.geometry.type === "polyline") {
        graphic.symbol = selectLine as any;
      }
      if (feature.geometry.type === "polygon") {
        graphic.symbol = selectPolygon as any;
      }
      if (feature.geometry.type === "rectangle") {
        graphic.symbol = selectRectangle as any;
      }
      if (feature.geometry.type === "circle") {
        graphic.symbol = selectCircle as any;
      }
      selectionGraphicLayer.add(graphic);
    }});
  });
}
export const createMapOfGraphicsInGraphicLayer =(graphicLayer)=>{
  let dict={}
  graphicLayer.graphics.forEach(graphic=>{
    let name = `${graphic.parentLayerId.replace(" ","-")}-${graphic.attributes['OBJECTID']}`
    dict[name]=graphic.attributes['OBJECTID']
  })
  return dict

}
const isFeatureDuplicateInGraphicLayerMap = (feature,graphicLayerMap)=>{

  let featureName = `${feature.layer.id.replace(" ","-")}-${feature.attributes['OBJECTID']}`

  if(!graphicLayerMap.hasOwnProperty(featureName)){
    return false
  }
  if(feature.attributes['OBJECTID']===graphicLayerMap[featureName]){
    return true
  }

}
export const removeAllFromSelectionLayer = (layerCollection: __esri.Collection<__esri.Layer>) => {
  const selectionLayer = layerCollection.find((layer) => layer.id === "selectionLayer");
  if (selectionLayer && selectionLayer.type === "graphics") {
    (selectionLayer as __esri.GraphicsLayer).removeAll();
  }
}